function PasswordStrengthService() {
    this.sets = [];
}

PasswordStrengthService.prototype.add = function (label, regex, score) {
    this.sets.push({ label, regex, score });
};

PasswordStrengthService.prototype.init = function () {
    this.add('ASCII Lowercase', /[a-z]/, 26);
    this.add('ASCII Uppercase', /[A-Z]/, 26);
    this.add('ASCII Numbers', /\d/, 10);
    this.add('ASCII Top Row Symbols', /[!@£#\$%\^&\*\(\)\-_=\+]/, 15);
    this.add('ASCII Other Symbols', /[\?\/\.>\,<`~\\|"';:\]\}\[\{\s]/, 19);

    // Unicode Latin Subset
    this.add('Unicode Latin 1 Supplement', /[\u00A1-\u00FF]/, 94);
    this.add('Unicode Latin Extended A', /[\u0100-\u017F]/, 128);
    this.add('Unicode Latin Extended B', /[\u0180-\u024F]/, 208);
    this.add('Unicode Latin Extended C', /[\u2C60-\u2C7F]/, 32);
    this.add('Unicode Latin Extended D', /[\uA720-\uA7FF]/, 29);

    // Unicode Cyrillic Subset
    this.add('Unicode Cyrillic Uppercase', /[\u0410-\u042F]/, 32);
    this.add('Unicode Cyrillic Lowercase', /[\u0430-\u044F]/, 32);
};

PasswordStrengthService.prototype.getPasswordStrength = function (password, goal) {
    let characters = 0;
    let entropy = 0;
    const length = this.sets.length;

    for (let index = 0; index < length; index++) {
        const match = this.sets[index].regex.test(password);
        if (match) {
            characters += this.sets[index].score;
        }
    }

    entropy = (Math.log(characters) / Math.LN2) * password.length;

    return Math.min(100, Math.round(100 * entropy / goal));
};

module.exports = PasswordStrengthService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/password-strength-service.js
 **/